import React from 'react';
import PropTypes from 'prop-types';
import { getFieldErrorText } from '../../utils/field-validation';
import TextField from '../widgets/TextField';
import FormFieldContainer from '../formFieldContainer';
import forEach from 'lodash/forEach';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import { injectIntl } from 'react-intl';
import ContentContainer from '../contentContainer';
import Checkbox from '../widgets/Checkbox';
import Paper from '@material-ui/core/Paper';
import { 
	Card, 
	CardHeader, 
	CardContent 
} from '@material-ui/core';
import { toCurrency } from '../../utils/utils';
import ForecastScheduleCard from './ForecastScheduleCard';
import FloatingActionButton from '@material-ui/core/Fab';
import ContentAdd from '@material-ui/icons/Add';
import DataTable from '../widgets/dataTable';
import { units, errorColour } from '../../variables';
import IconButton from '../widgets/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import DataTableTextEditor from '../widgets/dataTableTextEditor';
import DataTableNumericEditor from '../widgets/dataTableNumericEditor';
import DataTableSelectEditor from '../widgets/DataTableSelectEditor';
import remove from 'lodash/remove';
import find from 'lodash/find';
import uniqueId from 'lodash/uniqueId';
import cloneDeep from 'lodash/cloneDeep';
import { globals } from '../../globals';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import ExpandIcon from '@material-ui/icons/ExpandMore';
import TextEditor from '../widgets/TextEditor';

const useStyles = makeStyles((theme) => ({
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		})
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	}
}));

const ForecastForm = props => {
	const classes = useStyles();
	const tableRef = React.useRef(null);
	const prevForecastRef = React.useRef();
	const [expandTempItems, setExpandTempItems] = React.useState(false);

	const forecast = props.forecast || { tempItems: [] };

	// React.useEffect(() => {
	// 	setForeecast(props.forecast);
	// }, [props.forecast])

	React.useEffect(() => {
		const prevForecast = prevForecastRef.current;

		// Focus the first field when a new item is added
		if (forecast && prevForecast && forecast.tempItems && prevForecast.tempItems && forecast.tempItems.length > prevForecast.tempItems.length) {
			if (tableRef && tableRef.current) {
				const table = tableRef.current;
				let lastRow = table.rows[table.rows.length - 1];
				if (lastRow && lastRow.cells.length > 1) {
					let inputElement = lastRow.cells[1].querySelector('input');
					if (inputElement) {
						inputElement.focus();
					}
				}
			}
		}

		prevForecastRef.current = forecast;
	}, [forecast])
	
	const forecastItems = forecast.items || [];
	const forecastTempItems = forecast.tempItems || [];
	console.log('forecastTempItems', forecastTempItems);
	
	const isOutOfLimits = (i) => {
		if (i._appliedForecastQty && i.limit) {
			const lowerLimit = (1 - i.limit) * i.qty * i.rate;
			const upperLimit = (1 + i.limit) * i.qty * i.rate;
			const forecastAmount = i._appliedForecastQty * i.rate;
			if (forecastAmount < lowerLimit || forecastAmount > upperLimit) {
				return true;
			}
		}

		return false;
	};
	let total = 0;
	forEach(forecastItems, (i) => {
		if (i.forecastQty !== null) {
			i._appliedForecastQty = i.forecastQty;
			i._difference =  (i.forecastQty * i.rate) - (i.qty * i.rate);
		} else if (i.prevForecastQty !== null) {
			i._appliedForecastQty = i.prevForecastQty;
			i._difference =  (i.prevForecastQty * i.rate) - (i.qty * i.rate);
		} else {
			i._appliedForecastQty = i.qty;
			i._difference =  0;
		}
		total += i._appliedForecastQty * i.rate;

		// Check limits of accuracy
		i._isOutOfLimits = isOutOfLimits(i);
	});
	forEach(forecastTempItems, (i) => {
		if (i.forecastQty !== null) {
			i._appliedForecastQty = i.forecastQty;
		} else if (i.prevForecastQty !== null) {
			i._appliedForecastQty = i.prevForecastQty;
		} else {
			i._appliedForecastQty = 0;
		}
		total += i._appliedForecastQty * i.rate;
	});

	// forecastItems = filter(forecastItems, i => i._appliedForecastQty !== i.qty);

	const itemsBySchedule = groupBy(forecastItems, (i) => i.scheduleGroup);

	const onExpandTempItemsClick = () => {
		setExpandTempItems(!expandTempItems);
	};

	const addTempItem = () => {
		const newItem = cloneDeep(globals.templates.scheduleForecastTempItem);
		newItem._clientId = uniqueId("item-");
		newItem.unit = 'each';
		newItem.rate = 0;
		newItem.qty = 0;
		props.updateField('tempItems', [
			...forecast.tempItems,
			newItem
		]);
	};
	
	const tempItemColumns = [
		{
			name: 'commands',
			excludeFromSearch: true,
			excludeFromFilter: true,
			headerStyle: { width: '10px' },
			cellStyle: (args) => {
				const style = { textAlign: 'center' };
				if (args.data._itemNoError || args.data._unitError || args.data._qtyError || args.data._rateError) {
					style.borderLeft = `5px solid ${errorColour}`;
				}
				return style;
			},
			headerRenderer: (args) => {
				return (
					<div style={{ whiteSpace: 'nowrap' }}>
						<IconButton 
							onClick={ () => {
								addTempItem();
							} } style={{ padding: '2px' }}>
							<AddIcon />
						</IconButton>
					</div>
				);
			},
			cellRenderer: (args) => {
				return (
					<div style={{ whiteSpace: 'nowrap' }}>
						<IconButton 
							onClick={ () => {
								remove(forecast.tempItems, i => {
									return i.scheduleForecastTempItemId > 0 ? i.scheduleForecastTempItemId === args.data.scheduleForecastTempItemId : i._clientId === args.data._clientId;
								});
								props.updateField('tempItems', [...forecast.tempItems]);
							} } style={{ padding: '2px' }}>
							<DeleteIcon />
						</IconButton>
					</div>
				);
			}	
		},
		{
			name: 'itemNo',
			label: 'Item No',
			headerStyle: { minWidth: '200px' },
			tooltip: (args) => args.data._itemNoError,
			cellStyle: (args) => {
				if (args.data._itemNoError) {
					return {
						backgroundColor: '#FFC7CE'
					};
				}
				return undefined;
			},
			cellRenderer: (args) =>
				<DataTableTextEditor
					key={`${args.data._clientId}-itemNo`}
					value={args.data.itemNo} 
					multiline={false}
					fullWidth={true}
					onChange={(v) => { 
						const item = find(forecast.tempItems, i => i._clientId === args.data._clientId);
						if (item) {
							item.itemNo = v;
							if (item.itemNo) item._itemNoError = undefined;
							props.updateField('tempItems', forecast.tempItems);
						}
					}}

				/>
		},
		{
			name: 'description',
			label: 'Description',
			headerStyle: { minWidth: '300px' },
			cellRenderer: (args) =>
				<DataTableTextEditor
					key={`${args.data._clientId}-description`}
					value={args.value} 
					multiline={false}
					fullWidth={true}
					onChange={(v) => { 
						const item = find(forecast.tempItems, i => i._clientId === args.data._clientId);
						if (item) {
							item.description = v;
							props.updateField('tempItems', forecast.tempItems);
						}
					}}

				/>
		},
		{
			name: 'unit',
			label: 'Unit',
			headerStyle: { minWidth: '100px' },
			filterOperators: ['=', 'Contains', 'multi-select'],
			filterOptions: units,
			tooltip: (args) => args.data._unitError,
			cellStyle: (args) => {
				if (args.data._unitError) {
					return {
						backgroundColor: '#FFC7CE'
					};
				}
				return undefined;
			},
			cellRenderer: (args) =>
				<DataTableSelectEditor
					key={`${args.data._clientId}-unit`}
					value={args.value} 
					fullWidth={true}
					items={
						map(units, (u) => 
							({ value: u.key, label: u.text })
						)
					}
					onChange={(v) => { 
						const item = find(forecast.tempItems, i => i._clientId === args.data._clientId);
						if (item) {
							item.unit = v;
							if (item.unit) item._unitError = undefined;
							props.updateField('tempItems', forecast.tempItems);
						}
					}}

				/>
		},
		// {
		// 	name: 'qty',
		// 	label: 'Qty',
		// 	headerStyle: { minWidth: '100px' },
		// 	dataType: 'number',
		// 	tooltip: (args) => args.data._qtyError,
		// 	cellStyle: (args) => {
		// 		if (args.data._qtyError) {
		// 			return {
		// 				backgroundColor: '#FFC7CE'
		// 			};
		// 		}
		// 		return undefined;
		// 	},
		// 	cellRenderer: (args) =>
		// 		<DataTableNumericEditor
		// 			key={`${args.data._clientId}-qty`}
		// 			value={args.value} 
		// 			label="qty"
		// 			fullWidth={true}
		// 			nullable={true}
		// 			onChange={(v) => { 
		// 				const item = find(forecast.tempItems, i => i._clientId === args.data._clientId);
		// 				if (item) {
		// 					item.qty = v;
		// 					if (item.qty && item.qty > 0) item._qtyError = undefined;
		// 					props.updateField('tempItems', forecast.tempItems);
		// 				}
		// 			}}

		// 		/>
		// },
		{
			name: 'forecastQty',
			label: 'Forecast Qty',
			headerStyle: { minWidth: '100px' },
			dataType: 'number',
			cellRenderer: (args) => {
				const value = args.data.forecastQty;
				const hintText = args.data._appliedForecastQty;

				return (
				<DataTableNumericEditor
					type='decimal'
					key={`${args.data._clientId}-forecastQty`}
					hintText={hintText}
					value={value} 
					fullWidth={true}
					nullable={true}
					onChange={(v) => { 
						const item = find(forecast.tempItems, i => i._clientId === args.data._clientId);
						if (item) {
							item.forecastQty = v;
							props.updateField('tempItems', forecast.tempItems);
						}
					}}
				/>
				);
			}
		},
		{
			name: 'rate',
			label: 'Rate',
			headerStyle: { minWidth: '100px' },
			dataType: 'number',
			tooltip: (args) => args.data._rateError,
			cellStyle: (args) => {
				if (args.data._rateError) {
					return {
						backgroundColor: '#FFC7CE'
					};
				}
				return undefined;
			},
			cellRenderer: (args) =>
				<DataTableNumericEditor
					key={`${args.data._clientId}-rate`}
					label="rate"
					type="currency"
					value={args.value} 
					fullWidth={true}
					nullable={true}
					onChange={(v) => { 
						const item = find(forecast.tempItems, i => i._clientId === args.data._clientId);
						if (item) {
							item.rate = v;
							if (item.rate && item.rate > 0) item._rateError = undefined;
							props.updateField('tempItems', forecast.tempItems);
						}
					}}

				/>
		},
		{
			name: 'amount',
			label: 'Forecast Amount',
			headerStyle: { minWidth: '100px' },
			dataType: 'number',
			value: (args) => {
				return args.data.forecastQty * args.data.rate;
			},
			cellRenderer: (args) => {
				const amount = (args.data.forecastQty * args.data.rate).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
				return amount;
			}
		},
		{
			name: 'comments',
			label: 'Comments',
			headerStyle: { minWidth: '300px' },
			cellRenderer: (args) =>
				<DataTableTextEditor
					key={`${args.data._clientId}-addInfo`}
					value={args.value} 
					multiline={false}
					fullWidth={true}
					onChange={(v) => { 
						const item = find(forecast.tempItems, i => i._clientId === args.data._clientId);
						if (item) {
							item.comments = v;
							props.updateField('tempItems', forecast.tempItems);
						}
					}}

				/>
		}
	];

		return (
<div>
	<ContentContainer>
		<FormFieldContainer>
			<TextField
				value={forecast.name}
				fullWidth={true}
				onChange={(e, v) => { props.updateField('name', v); }}
				label="Name."
				errorText={getFieldErrorText(props.saveResult, 'Name')}
			/>
		</FormFieldContainer>

		<FormFieldContainer classes={{ s12: true, m6: true, hasToggle: true }} infoText="There can be only one active forecast. Setting this forecast to active will make any other forecast inactive.">
			<Checkbox
				label="Is Active"
				labelPosition="right"
				checked={forecast.isActive}
				onCheck={(e, v) => { props.updateField('isActive', v); }}
			/>
		</FormFieldContainer>
			
		<FormFieldContainer>
			<TextEditor
				value={forecast.comments}
				fullWidth={true}
				multiline={true}
				onChange={(e, v) => { props.updateField('comments', v); }}
				label="Comments"
				errorText={getFieldErrorText(props.saveResult, 'Comments')}
			/>
		</FormFieldContainer>
	</ContentContainer>

	{
		map(itemsBySchedule, (items) => {
			const scheduleName = items[0].scheduleGroup;
			
			return (
				<div>
					<ForecastScheduleCard
						scheduleName={scheduleName}
						items={items}
						updateForecastItem={props.updateForecastItem}
					/>
				</div>
			);
		})
	}

	<Card style={{ marginTop: '20px' }}>
		<CardHeader
			title="Temporary Items"
			titleTypographyProps={{
				variant: 'h6'
			}}
			action={
				<IconButton
					className={classnames(classes.expand, {
						[classes.expandOpen]: expandTempItems,
					})}
					onClick={onExpandTempItemsClick}
					aria-expanded={expandTempItems}
					aria-label="show more"
				>
					<ExpandIcon />
				</IconButton>
			}
		>
		</CardHeader>
		{expandTempItems &&
			<CardContent>
		
				<DataTable 
					data={forecastTempItems} 
					columns={tempItemColumns}
					tableRef={tableRef}
				/>
			</CardContent>
	}	
	</Card>


	<Paper 
		style={{ 
			float: 'right', 
			padding: '20px', 
			margin: '20px 0', 
			fontSize: '16px', 
			fontWeight: 'bold' 
		}}
	>
		<div>
			<span>Total: </span>
			<span>{toCurrency(total)}</span>
		</div>
	</Paper>
</div>
		);
};

ForecastForm.propTypes = {
	scheduleOfRates: PropTypes.array,
	forecast: PropTypes.object,
	updateField: PropTypes.func.isRequired,
	updateForecastItem: PropTypes.func.isRequired,
	saveResult: PropTypes.object.isRequired
};

ForecastForm.defaultProps = {
	scheduleOfRates: [],
	forecast: undefined
};

export default injectIntl(ForecastForm);
